<template>
  <section id="libros">
    <div id="breadcrumbs">
      <div class="bg-light py-3">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-0 text-left">
              <router-link to="/">Home</router-link>
              <span class="mx-2 mb-0">/</span>
              <strong class="text-black">Libros</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #breadcrumbs -->
    <div class="container d-flex justify-content-center">
      <div class="container-title">
        <h2>Libros</h2>
        <span class="icon icon-book"></span>
      </div>
    </div>
    <loading :active.sync="is_loading"></loading>
    <ProductList :no_product="message" :products="products"></ProductList>
  </section>
</template>

<script>
// @ is an alias to /src
import ProductList from "@/components/ProductList.vue";
import Loading from "vue-loading-overlay";
const axios = require("axios");

export default {
  name: "libros",
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      products: [],
      message: "",
      is_loading: true,
    };
  },
  mounted() {
    this.getLibros();
  },
  components: {
    ProductList,
    Loading,
  },
  methods: {
    getLibros: function () {
      this.message = "Cargando libros";
      axios({
        method: "GET",
        url: this.api_url + "/products/type/5",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("ctoken"),
        },
      })
        .then((response) => {
          this.products = response.data;
          console.info("Se obtuvieron los Libros");
          console.info(response.data);
          this.is_loading = false;
          if (this.products.length > 0)
            this.message = "Se obtuvieron los Libros";
          else this.message = "No se encontraron Libros que mostrar";
        })
        .catch((error) => {
          console.error(error);
          this.message = "No se encontraron Libros que mostrar";
        });
    },
  },
};
</script>
<style scoped>
.container-title {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #1a243a;
  border-radius: 15px;
  color: #1a243a;
  padding: 10px 35px;
}

.container-title h2 {
  margin: 0;
}

.icon {
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 10px;
  font-size: 40px;
  font-weight: 400;
}
</style>